import {
    AppsRegular, DatabaseRegular, DismissCircleRegular, AlertRegular,
    RocketRegular, ChartMultipleRegular, BranchRegular,
} from "@fluentui/react-icons";

export const navigation = [
    { path: "/", label: "Function catalog", group: "Workspace", icon: AppsRegular, description: "Discover and run engineering utilities." },
    { path: "/control-center", label: "Control center", group: "Operations", icon: ChartMultipleRegular, description: "Triage incidents, support requests, and pipeline health." },
    { path: "/pools", label: "CST pools", group: "Operations", icon: DatabaseRegular, description: "Explore shared test environments and leases." },
    { path: "/alertstatus", label: "Alert status", group: "Operations", icon: AlertRegular, description: "Review alerts and manage monitoring." },
    { path: "/cancelBuildPipelines", label: "Cancel builds", group: "Operations", icon: DismissCircleRegular, description: "Manage queued and running pipeline builds." },
    { path: "/release-reliability", label: "CST deployments", group: "Insights", icon: RocketRegular, description: "Investigate deployment health and reliability." },
    { path: "/pipeline-reliability", label: "Pipeline reliability", group: "Insights", icon: ChartMultipleRegular, description: "Explore pipeline outcomes and stage durations." },
    { path: "/commit-heatmap", label: "Commit heatmap", group: "Insights", icon: BranchRegular, description: "Understand code activity and revert patterns." },
];

export function getNavigationItem(pathname) {
    return navigation.find(({ path }) => path === "/"
        ? pathname === "/"
        : pathname.toLowerCase() === path.toLowerCase() || pathname.toLowerCase().startsWith(`${path.toLowerCase()}/`));
}
